/* eslint-disable react-native/sort-styles */
/* eslint-disable react-native/no-color-literals */
import { colors } from "colors"
import { Platform, StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  QRbuttonContainer: {
    borderColor: "white",
    borderRadius: 999,
    marginRight: 20,
    paddingLeft: 20,
  },
  bgWhite: { backgroundColor: colors.white },
  carouselContainer: {
    flex: 1,
    justifyContent: "center",
    maxWidth: colors.appMaxWidth,
  },
  carouselImage: {
    // borderRadius: 20,
    // flex: 1,
    height: "100%",
    maxWidth: colors.appMaxWidth,
    width: "100%",
    resizeMode: "contain",
  },
  categoryContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  categoryContentContainer: { alignItems: "center", marginBottom: 20, width: "25%" },
  categoryText: {
    fontFamily: typography.primary.normal,
    fontSize: 10,
    marginTop: 5,
    textAlign: "center",
  },
  container: {
    backgroundColor: "transparent",
    bottom: -15,
    flex: 1,
    maxWidth: 800,
    top: -10,
    width: "100%",
    zIndex: 100,
  },
  curveTop: {
    position: "absolute",
    top: -15,
    left: 0,
    right: 0,
    height: 30,
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    backgroundColor: "white",
  },
  curveBottom: {
    position: "absolute",
    bottom: -15,
    left: 0,
    right: 0,
    height: 30,
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    backgroundColor: "white",
  },
  curvedLine: {
    width: "100%",
    height: 40,
    backgroundColor: "white", // Color of the curve background
    borderTopLeftRadius: 100, // Radius for left curve
    borderTopRightRadius: 100, // Radius for right curve
    borderBottomWidth: 2,
    borderColor: "#E0E0E0", // Optional border color for the bottom edge of the curve
    position: "absolute",
    top: 10,
  },
  headerBottomContainer: {
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    display: "flex",
    height: "100%",
    flex: 1,
    justifyContent: "center",
    padding: 10,
  },
  headerBottomRightCurveContainer: {
    backgroundColor: "transparent",
    height: "100%",
    position: "absolute",
    width: "100%",
    zIndex: 999,
  },
  headerContainer: { flexDirection: "row", justifyContent: "space-between", width: "100%" },
  headerFullContainer: {
    width: colors.appMaxWidth,
    zIndex: 10000,
  },
  headerHiText: { color: colors.white, fontSize: 18, marginLeft: 10 },
  headerLeft: {
    alignItems: "center",
    backgroundColor: colors.headerNameBg,
    borderRadius: 99,
    height: 40,
    justifyContent: "center",
    width: 40,
  },
  headerLeftContainer: {
    alignItems: "flex-start",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "70%",
  },
  hidePopUpText: {
    textDecorationLine: "underline",
    alignSelf: "flex-end",
    color: "white",
    marginTop: 10,
    fontSize: 16,
  },
  headerPointContainer: {
    alignItems: "center",
    backgroundColor: colors.whitePlaceholder,
    borderColor: colors.lighterGrey,
    borderRadius: 10,
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 10,
    marginRight: 20,
    marginTop: 15,
    padding: 10,
    paddingVertical: 5,
  },
  headerPointContentContainer: { alignItems: "center", flexDirection: "row" },
  headerQrButton: { alignSelf: "center", flex: 1, justifyContent: "center" },
  headerQrButtonContainer: {
    borderRadius: 99,
    height: 80,
    width: 80,
    alignSelf: "center",
  },
  headerQrContainer: {
    backgroundColor: colors.linearSecondColor,
    width: 105,
    // overflow: "hidden",
  },
  headerQrContainerBackground: {
    alignItems: "center",
    backgroundColor: colors.white,
    borderBottomLeftRadius: 33,
    borderTopRightRadius: 999,
    borderTopStartRadius: 999,
    height: 125,
    position: "absolute", // Changed from "fixed" to "absolute"
    width: 125,
    zIndex: 5,
  },

  headerQrText: { color: colors.white, fontFamily: typography.primary.normal, marginTop: 5 },
  headerRightContainer: { marginRight: 10 },
  headerSingleUsername: { color: colors.lightGrey, fontSize: 18 },
  headerTierLogo: {
    bottom: -2,
    height: 15,
    position: "absolute",
    right: -2,
    width: 15,
    zIndex: 10,
  },
  headerTopGradientContainer: { flex: 1, height: 30, width: "100%", zIndex: 0 },
  headerTopRightGradientContainer: {
    backgroundColor: colors.linearSecondColor,
    height: "100%",
    width: 108,
  },
  linearGradient: { height: 140, width: "100%", zIndex: 0 },
  ml20: { marginLeft: 20 },
  modalButton: { marginTop: 20 },
  modalContainer: {
    alignSelf: "center",
    backgroundColor: colors.white,
    borderRadius: 10,
    maxWidth: 800,
    padding: 20,
  },
  modalTitle: { fontFamily: typography.primary.normal, fontSize: 25, marginBottom: 10 },

  mt10: { marginTop: 10 },
  mt15: { marginTop: 15 },
  paginationDot: {
    backgroundColor: colors.carouselPAgination,
    borderRadius: 50,
    height: 8,
    marginRight: 5,
    overflow: "hidden",
    width: 8,
  },
  paginationDotContainer: {
    alignSelf: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  profileImage: { borderRadius: 999, height: 35, width: 35 },
  profileImageContainer: {
    borderRadius: 999,
    overflow: "hidden",
    width: 100, // Adjust as needed
    height: 100, // Adjust as needed
  },
  row: { flexDirection: "row" },
  showAllText: {
    fontFamily: typography.primary.normal,
    fontSize: 14,
  },
  stamp: {
    backgroundColor: "#D3D3D3",
  },
  text: { color: colors.white, fontFamily: typography.primary.normal },
  tierContainer: { flexDirection: "row", justifyContent: "space-between" },
  tierContentContainer: {
    borderRadius: 10,
    marginTop: 10,
  },
  tierImage: { alignSelf: "center", height: 50, width: 50 },
  tierSpendText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    marginTop: 3,
  },
  tierText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    marginBottom: 10,
  },
  voucherContainer: { marginRight: 20 },
  voucherImage: {
    alignSelf: "center",
    borderRadius: 10,
  },

  voucherText: {
    fontFamily: typography.primary.normal,
    marginTop: 10,
  },
  pointContainer: {
    backgroundColor: colors.pivilegePointContainer,
    borderRadius: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 10,
    paddingHorizontal: 10,
  },

  stampContainer: {
    borderRadius: 10,
    overflow: Platform.OS === "android" ? "hidden" : "visible", // 'hidden' clips shadow on iOS
    backgroundColor: "#fff", // Required for elevation to work correctly
    padding: 5,
    paddingVertical: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.18,
    shadowRadius: 4,
    elevation: 5, // Effective range: 1–24 for Android
    marginBottom: 15,
  },

  stampTextContainer: {
    padding: 5,
  },
  stampImage: {
    alignSelf: "center",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  unactiveFilter: {
    borderWidth: 2,
    borderRadius: 8,
    borderColor: colors.buttonBackground,
    marginRight: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  unactiveFilterText: {
    marginHorizontal: 20,
    color: colors.buttonBackground,
  },
  activeFilter: {
    borderWidth: 2,
    borderRadius: 8,
    borderColor: colors.buttonBackground,
    backgroundColor: colors.buttonBackground,
    marginRight: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  activeFilterText: {
    marginHorizontal: 20,
    color: colors.white,
  },
  desc_text: {
    color: colors.black,
    fontFamily: typography.thin.normal,
    fontSize: 10,
  },
  stampProgressContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
    paddingHorizontal: 5,
    width: "100%",
  },
  stampSegment: {
    width: 20,
    height: 6,
    backgroundColor: "#E0E0E0",
    borderRadius: 2,
  },
  stampCountText: {
    fontSize: 12,
    color: colors.lightGrey,
  },
  title: {
    fontFamily: typography.primary.normal,
    fontSize: 18,
    fontWeight: "bold",
  },
})
